import React, { useRef, useCallback, Fragment } from 'react';
import { handleSetCurrentEntity } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';
import ColorPicker from 'components/pages/livefeed/Editor/EditorContainer/common/ColorPicker'

const BgColorOption = (props) => {
    const colorPickerRef = useRef(null)
    const { slideType, dispatch, currentEntity, leftPanelBg, slideBg, rightPanelBg, editorView } = props

    const setEntity = useCallback((e, entity) => {
        e.preventDefault();
        e.stopPropagation();
        handleSetCurrentEntity(currentEntity, entity, dispatch)
    }, [currentEntity, dispatch])

    function handleChangeBg(e, entity) {
        setEntity(e, entity)
        colorPickerRef.current.openColorPicker()
    }
    let fillLineColor
    if (currentEntity.id === "leftPanelBg" ||
        currentEntity.id === "rightPanelBg" ||
        currentEntity.id === "rightPanelGaugeOccupiedBg" ||
        currentEntity.id === "rightPanelGaugeOffsetdBg" ||
        currentEntity.id === "rightPanelGaugeNeedle") {
        fillLineColor = currentEntity.color
    } else {
        fillLineColor = "#aaaaaa"
    }
    let toggleable;
    if (
        currentEntity.id === "rightPanelGaugeOccupiedBg" ||
        currentEntity.id === "rightPanelGaugeOffsetdBg" ||
        currentEntity.id === "rightPanelGaugeNeedle" ||
        editorView === false) {
        toggleable = false
    } else {
        toggleable = true
    }

    return (
        <Fragment>
            {toggleable === false ?
                <div
                    onClick={() => editorView ? colorPickerRef.current.openColorPicker() : null}
                    data-tooltip="Change background color">
                    <div className={`icon-wrapper justify-center icon-wrapper_color ${editorView ? '' : 'icon-wrapper_color_disable'}`}>
                        <svg width='24' height='24' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path className="shape" d="M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 000 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z" />
                            <path className="Color-Line" fill={fillLineColor} d="M0 20h24v4H0z" />
                        </svg>
                    </div>
                </div>
                :
                <div data-tooltip="Change livefeed background color" style={{ zIndex: 3 }}>
                    <Dropdown
                        className="toolbar-dropdown"
                        noArrow={true}
                        header={
                            <div className={`icon-wrapper justify-center icon-wrapper_color ${editorView ? '' : 'icon-wrapper_color_disable'}`} >
                                <svg width='24' height='24' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path className="shape" d="M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 000 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z" />
                                    <path className="Color-Line" fill={fillLineColor} d="M0 20h24v4H0z" />
                                </svg>
                            </div>
                        }
                        toggleable={toggleable}
                        dropdownItemsWrapperStyle={{ width: "unset" }}
                    >
                        <React.Fragment>
                            {(slideType === "summary" || slideType === "locationsList") ?
                                <DropdownItem>
                                    <div onClick={(e) => handleChangeBg(e, slideBg)}>
                                        Change background color
                                    </div>
                                </DropdownItem>
                                :
                                <React.Fragment>
                                    <DropdownItem>
                                        <div onClick={(e) => handleChangeBg(e, leftPanelBg)}>
                                            Change Panel Left background color
                                    </div>
                                    </DropdownItem>
                                    <DropdownItem>
                                        <div onClick={(e) => handleChangeBg(e, rightPanelBg)}>
                                            Change Panel Right background color
                                    </div>
                                    </DropdownItem>
                                </React.Fragment>
                            }
                        </React.Fragment>
                    </Dropdown>
                </div>
            }
            <ColorPicker
                clickable={editorView}
                ref={colorPickerRef}
                dispatch={dispatch}
            />
        </Fragment>
    );
}


export default BgColorOption;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/ToolbarOptions/BgColorOption.jsx